import { Box, Text } from '@cmpsr/components';
import React from 'react';

/**
 * Displays the "Loading your free Preliminary Risk Assessment" message.
 */
const LoadingMessage: React.FC = () => {
  return (
    <Box mx={{ base: 'spacer-2', lg: 'spacer-4' }} textAlign="center">
      <Text
        color="darkBlue"
        variant={{ lg: 'text-header-S', base: 'text-header-XS' }}
        textAlign="center"
        mb="spacer-7"
        textTransform="uppercase"
        letterSpacing="0.1rem"
      >
        Discover your risk
      </Text>
      <Text
        color="darkBlue"
        textAlign="center"
        mb="spacer-2"
        variant={{ lg: 'text-header-XL', base: 'text-header-XL' }}
      >
        Loading your{' '}
        <Text
          as="span"
          color="darkBlue"
          variant={{ lg: 'text-header-2XL', base: 'text-header-2XL' }}
          fontFamily="libreBaskerville"
          fontStyle="italic"
        >
          free
        </Text>{' '}
        <Text
          as="span"
          textDecoration="underline"
          textUnderlineOffset="0.22em"
          color="darkBlue"
          variant={{ lg: 'text-header-XL', base: 'text-header-XL' }}
          textDecorationThickness="0.125rem"
        >
          Preliminary
        </Text>{' '}
        Risk Assessment
      </Text>
      <Text
        color="darkBlue"
        textAlign="center"
        variant={{ base: 'text-body-display-XS', lg: 'text-body-display-XS' }}
        fontSize={{ base: 'spacer-3', lg: 'spacer-4' }}
        fontWeight={400}
        lineHeight="130%"
      >
        Join thousands of Catch members reducing their risk by up to 60%
      </Text>
    </Box>
  );
};

export default LoadingMessage;
